import { Box, Divider, Stack, Toolbar } from '@mui/material'
import { Link } from 'react-router-dom'

import LanguageToggle from '../LanguageToggle/LanguageToggle.jsx'
import Logo from '../Logo/Logo.jsx'
import ProfileBadge from '../ProfileBadge/ProfileBadge.jsx'
import ThemeToggle from '../ThemeToggle/ThemeToggle.jsx'

const NavBar = () => {
  return (
    <>
      <Toolbar>
        <Link to="/select-test">
          <Box sx={{
            width: '140px',
            margin: 'auto'
          }}>
            <Logo />
          </Box>
        </Link>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          edge="end"
          sx={{ padding: '5px 16px' }}
        >
          <ThemeToggle />
          <LanguageToggle />
        </Stack>
        <Divider
          orientation="vertical"
          flexItem
        />
        <ProfileBadge />
      </Toolbar>
    </>
  )
}

export default NavBar
